import settings from 'shared/settings';
import http from 'shared/utils/http';


const { paypal: paypalHost } = settings.hosts;

const options = {
  withCredentials: false,
};


function rejectIfNotAllParamsAreTruthy(func) {
  return function () {
    if (arguments.length !== func.length || !_.every(arguments)) {
      return Promise.reject();
    }

    return func(...arguments);
  };
}


export default {
  checkConnection: rejectIfNotAllParamsAreTruthy(function checkConnection(userId, instance) {
    return http.get(`${paypalHost}vod/pp/permissions/check`, {
      params: { userId, instance },
      options,
    });
  }),

  disconnect: rejectIfNotAllParamsAreTruthy(function disconnect(userId, instance) {
    return http.get(`${paypalHost}vod/pp/permissions/cancel`, {
      params: { userId, instance },
      options,
    });
  }),
};



// WEBPACK FOOTER //
// ./src/shared/utils/adapters/payments/paypal.js